import React, { useEffect, useState } from "react";
import { Footer } from "../../Footer";
import DataTable from "react-data-table-component";
import { Button, Col, Form, InputGroup, Row, Table } from "react-bootstrap";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import * as icons from "react-bootstrap-icons";
import {
  SportAllMap,
  TeamGetAll,
  TeamGetBy,
  TournamentAll,
  TournamentAllData,
  TournamentAllDataSearch,
  TournamentDelete,
  TournamentUpdate,
} from "../../redux/auth-reducer/auth-service";
import { ImageUrl } from "../../utils/config/config";
import { useImageUpload } from "../../hooks/useImageUpload";
import { readApiMessage } from "../../utils/helper/helper";
import { IMAGE_STILL_UPLOADING } from "../../utils/helper/imageUpload";
import { ModalBox } from "../Outer/Modal";
import { ImageFileInput } from "./ImageFileInput";
import { FormActions } from "./FormActions";
import { ConfirmDeleteModal } from "./ConfirmDeleteModal";
import { ToastContainer, toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import { DatePicker } from "rsuite";
import dayjs from "dayjs";
import moment from "moment";

export const Tournament = () => {
  const [data, setData] = useState();
  const [validated, setValidated] = useState(false);
  const [itemList, setItemList] = useState("");
  const [splitedTeamID, setSplitedTeamID] = useState([]);
  const [count, setCount] = useState(0);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteRow, setDeleteRow] = useState(null);
  const [selectedTeam, setSelectedTeam] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [showEdit, setShowEdit] = useState();
  const [showView, setShowView] = useState(false);
  const [selectedSport, setSelectedSport] = useState([]);
  // The logo Update Contest saves. See useImageUpload for what a failed upload does: it used to save
  // the contest with no logo, and an upload made while editing one contest carried over to the next.
  const editLogo = useImageUpload();
  const [error, setError] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [sportIdData, setSportIdData] = useState();
  const [selectedSportId, setSelectedSportId] = useState([]);
  const [regularTeam, setRegularTeam] = useState([]);
  const [nonTeamFeild, setnonTeamFeild] = useState([]);
  const [selectedOptionsFeild, setSelectedOptionsFeild] = useState([]);
  const [dataListItemTeam, setDataListItemTeam] = useState();
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const pageOptions = [10, 20, 30, 50];
  const navigate = useNavigate();
  function sidebarfun() {
    setData(!data);
  }
  const [editData, setEditData] = useState({
    tournamentName: "",
    tournamentImage: null,
    startDate: "",
    endDate: "",
    minBid: "",
    bidIncrement: "",
    fK_SportId: "",
    TeamId: "",
  });

  // useEffect(() => {

  //     const TournamentAllFn = async () => {
  //         await TournamentAll().then((response) => {

  //             setItemList(response?.data?.data?.dataList);

  //         })
  //     }
  //     TournamentAllFn();

  // }, [count])
  const TournamentGetAll = async (data) => {
    try {
      const response = await TournamentAllData(data); // Call your API function
      if (response?.data) {
        setItemList(response.data.data.dataList || []); // Set the item list
        setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const data = {
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: false,
    };
    TournamentGetAll(data); // Fetch data when currentPage changes
  }, [currentPage, count]);

  const handlePerPageChange = (event) => {
    const newPerPage = Number(event.target.value);
    const data = {
      PageNumber: currentPage,
      PageSize: newPerPage,
      SortOrder: false,
    };
    TournamentGetAll(data);

    setPerPage(newPerPage); // Update items per page
    setCurrentPage(1); // Reset to first page when items per page changes
  };

  // Handle page change
  const handleNextPage = () => {
    if (currentPage < Math.ceil(totalRows)) {
      setCurrentPage((prevPage) => prevPage + 1); // Go to next page
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1); // Go to previous page
    }
  };

  // const handlePageChange = page => {
  //     setPageNo(page);
  //     const data = {
  //         "PageNumber": page,
  //         "PageSize": perPage
  //     }
  //     TeamAllFn(data);
  // };

  useEffect(() => {
    const TeamGet = async () => {
      await TeamGetAll().then((res) => {
        setSelectedTeam(res?.data?.data?.dataList);
      });
    };
    TeamGet();
  }, []);

  function convertUTCToLocalTime(utcDateString) {
    const date = new Date(utcDateString);
    return date.toString(); // Or use date.toLocaleString() for better format
  }
  const isUser = JSON.parse(localStorage.getItem("isUser"));

  const columns = [
    {
      name: <strong>Id</strong>,
      selector: (row, index) => (currentPage - 1) * perPage + index + 1,
      width: "60px",
    },

    {
      name: <strong> Logo</strong>,
      selector: (row) => (
        <>
          {row?.tournamentImage === null ? (
            <img
              src="../image/tournament.png"
              width={50}
              className="img-fluid pt-3 pb-3"
            />
          ) : (
            <img
              src={ImageUrl + row?.tournamentImage}
              className="m-2"
              width={50}
            />
          )}
        </>
      ),
      width: "90px",
    },
    {
      name: <strong>Contest Name</strong>,
      selector: (row) => row?.tournamentName,
      sortable: true,
      wrap: true,
    },

    {
      name: <strong>Sport Name</strong>,
      selector: (row) => row?.sportName,
      sortable: true,
      wrap: true,
    },

    {
      name: <strong>Start Date & Time</strong>,
      selector: (row) => {
        if (!row?.startDate) return <p>Invalid date</p>;
        return (
          <p>{dayjs(row?.startDate + "Z").format("MM/DD/YYYY hh:mm A")}</p>
        );
      },
      wrap: true,
    },

    {
      name: <strong>End Date & Time</strong>,
      selector: (row) => {
        if (!row?.endDate) return <p>Invalid date</p>;

        return (
          <p>{dayjs(row?.endDate + "Z").format("MM/DD/YYYY hh:mm A")}</p>
        );
      },
      wrap: true,
    },

    {
      name: <strong>Team</strong>,
      selector: (row) => (
        <>
          <button
            type="button"
            className="btn btn-primary viewButton"
            onClick={() => viewFn(row)}
          >
            {" "}
            <icons.Eye /> Team
          </button>
        </>
      ),
      width: "130px",
    },
    {
      name: <strong>Action</strong>,
      selector: (row) => (
        <>
          {/*
            #158: every contest is a no-bracket contest, whatever the sport's isBracket flag says,
            so every row gets this button - the match date and player scores the prize payout is
            paid from. #213: labelled Publish Results, in the slot Show Bracket had. A contest
            built as a bracket before #158 shows an empty list until it is saved once, which
            rebuilds it.
          */}
          <Button
            type="button"
            variant="primary"
            onClick={() => openResults(row?.tournamentId)}
          >
            Publish Results
          </Button>

          {row?.createdBy === isUser?.userId ? (
            <button
              type="button"
              className="text-danger btn-aucion"
              onClick={() => deleteFn(row)}
            >
              <icons.Trash />
            </button>
          ) : (
            <button
              type="button"
              disabled
              className="text-danger btn-aucion disabled"
              onClick={() => deleteFn(row)}
            >
              <icons.Trash />
            </button>
          )}

          {row?.createdBy === isUser?.userId ? (
            <button
              type="button"
              className="text-success btn-aucion"
              onClick={() => editFn(row)}
            >
              <icons.PencilSquare />
            </button>
          ) : (
            <button
              type="button"
              disabled
              className="text-success btn-aucion disabled"
              onClick={() => editFn(row)}
            >
              <icons.PencilSquare />
            </button>
          )}
        </>
      ),
      width: "250px",
    },
  ];
  const openResults = (tournamentId) => {
    navigate(`/SuperAdmin/ContestResults/${tournamentId}`);
  };

  // #307: the whole row, so the confirmation can name the contest.
  const deleteFn = (row) => {
    setShowDeleteModal(true);
    setDeleteRow(row);
  };

  const viewFn = (viewItem) => {
    setEditData(viewItem);
    setShowView(true);

    let arrayID = viewItem?.teamId?.split(",").map(Number);

    const isFieldValues = viewItem?.isField?.split(",").map(Number);

    const teamStatusMap = arrayID?.reduce((acc, teamId, index) => {
      acc[teamId] = isFieldValues[index];
      return acc;
    }, {});

    setDataListItemTeam(teamStatusMap);

    setSplitedTeamID(arrayID);
  };

  const editFn = (editList) => {
    setShowEdit(true);
    setEditData({ ...editList });
    editLogo.reset(editList?.tournamentImage);
  };

  useEffect(() => {
    var listItem = selectedSportId
      ? selectedSportId.map((list) => {
          return { label: list?.teamName, value: list?.teamId };
        })
      : [];
    var options = [...listItem];
    setRegularTeam(options);
    // selectedOptionsFeild(options)
  }, [selectedSportId]);

  useEffect(() => {
    var listItem = selectedSportId
      ? selectedSportId.map((list) => {
          return { label: list?.teamName, value: list?.teamId };
        })
      : [];
    var options = [...listItem];
    setnonTeamFeild(options);
  }, [selectedSportId]);

  useEffect(() => {
    if (editData) {
      // Split the comma-separated values and convert them to numbers
      const teamIds = editData.teamId?.split(",").map(Number);
      const isFieldValues = editData.isField?.split(",").map(Number);

      const teamStatusMap = teamIds?.reduce((acc, teamId, index) => {
        acc[teamId] = isFieldValues[index];
        return acc;
      }, {});
      const regularTeams = regularTeam.filter(
        (item) => teamStatusMap[item.value] === 0
      );

      const fieldTeams = nonTeamFeild.filter(
        (item) => teamStatusMap[item.value] === 1
      );

      setSelectedOptions(regularTeams);
      setSelectedOptionsFeild(fieldTeams);
    }
  }, [editData, regularTeam, nonTeamFeild]);

  const handelDelete = async () => {
    await TournamentDelete(deleteRow?.tournamentId).then((res) => {
      if (res?.status == true) {
        setCount(count + 1);
        toast.success(res?.message);
        setShowDeleteModal(!showDeleteModal);
      } else {
        toast.error(readApiMessage(res));
      }
    });
  };

  const handelselect = (e) => {
    setSelectedOptions(e);
  };

  const handelselectFeild = (selected) => {
    setSelectedOptionsFeild(selected);
    setError("");
  };

  const getDisabledRegularOptions = () => {
    const selectedFieldValues = selectedOptionsFeild?.map(
      (option) => option?.value
    );
    if (selectedFieldValues) {
      return regularTeam?.map((option) => ({
        ...option,
        disabled: selectedFieldValues.includes(option.value),
      }));
    }
  };

  const getDisabledFieldOptions = () => {
    const selectedRegularValues = selectedOptions?.map(
      (option) => option?.value
    );
    if (selectedRegularValues) {
      return nonTeamFeild?.map((option) => ({
        ...option,
        disabled: selectedRegularValues.includes(option.value),
      }));
    }
  };

  const handelFrom = (e) => {
    setEditData({
      ...editData,
      [e.target.name]: e.target.value,
    });
  };

  const handelFromSport = (e) => {
    setSportIdData(e.target.value);

    setEditData({
      ...editData,
      [e.target.name]: e.target.value,
    });
  };

  const handelStartDate = (date) => {
    setEditData({
      ...editData,
      startDate: date,
    });
  };

  const handelEndDate = (date) => {
    setEditData({
      ...editData,
      endDate: date,
    });
  };

  // #309: a cleared picker shows empty (it kept the old date), so its error is not shown under one.
  useEffect(() => {
    if (editData?.endDate) {
       var localTime = moment.utc(editData?.endDate).local().format();
      setEndDate(new Date(localTime));
    } else {
      setEndDate(null);
    }
  }, [editData]);
  // useEffect(() => {
  //   if (editData?.endDate) {
  //     const localTime = convertUTCToLocalTime(editData?.endDate + "Z");
  //     const dayjsDate = dayjs(localTime);
  //     setEndDate(dayjsDate.toDate());
  //   }
  // }, [editData]);

  // useEffect(() => {
  //   if (editData?.startDate) {
  //     const localTime = dayjs(editData.startDate + "Z").format(
  //       "MM/DD/YYYY hh:mm:ss A"
  //     );

  //     // dayjs(row?.startDate + "Z").format("MM/DD/YYYY hh:mm:ss A")}
  //     const dayjsDate = dayjs(localTime);

  //     // setStartDate(dayjsDate.toDate());

  //     setStartDate(dayjsDate.toDate());
  //   }
  // }, [editData]);

  useEffect(() => {
      if (editData?.startDate) {
        var localTime = moment.utc(editData?.startDate).local().format();
        setStartDate(new Date(localTime));
      } else {
        setStartDate(null);
      }
    }, [editData]);

  const handleClosed = () => {
    setShowDeleteModal(false);
    setShowView(false);
    setShowEdit(false);
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    if (value.length === 1 && value === " ") {
      return; // Ignore the input if it's just a space
    }
    setSearchText(value);
    const data = {
      SearchTerm: value,
      SortOrder: false,
      SortColumn: "TeamName",
    };
    TournamentGetAllSearch(data);
  };

  const filteredData = searchText
    ? itemList.filter((item) => {
        return (
          item?.tournamentName
            ?.toLowerCase()
            .includes(searchText?.toLowerCase()) ||
          item.sportName?.toLowerCase().includes(searchText?.toLowerCase())
        );
      })
    : itemList;

  useEffect(() => {
    const SportGet = async () => {
      await SportAllMap().then((res) => {
        setSelectedSport(res?.data?.data?.dataList);
      });
    };
    SportGet();
  }, []);

  useEffect(() => {
    if (!editData?.sportId) {
      setSelectedSportId([]);
      return;
    }
    const SportGetTeam = async () => {
      await TeamGetBy(editData?.sportId).then((res) => {
        // The endpoint returns a bare list, so a failure body is an object, not an array (#109).
        setSelectedSportId(Array.isArray(res) ? res : []);
      });
    };
    SportGetTeam();
  }, [editData?.sportId]);

  const handleUpdate = async (e) => {
    e.preventDefault();
    setValidated(true);
    const form = e.currentTarget;

    // Validate selected options
    if (selectedOptions?.length === 0) {
      toast.error("Please select at least one option");
      return;
    } else {
      setError("");
    }

    if (editLogo.uploading) {
      toast.error(IMAGE_STILL_UPLOADING);
      return;
    }

    // #309: rsuite's pickers are not checked by checkValidity(); a cleared date shows its error
    // (validated is set above) and is not sent.
    if (!editData?.startDate || !editData?.endDate) {
      return;
    }

    if (form.checkValidity() === true) {
      // Initialize teamid from editData
      let teamid = [];

      // Check if editData.teamId is a string and split it into an array
      if (typeof editData?.teamId === "string") {
        teamid = editData.teamId.split(",").map(Number); // Split string into an array and convert to numbers
      } else if (Array.isArray(editData?.teamId)) {
        teamid = editData.teamId.map(Number); // If it's already an array, use it directly
      } else {
        console.error(
          "editData.teamId is not a valid array or string:",
          editData?.teamId
        );
      }
      const selectedRegularTeamIds = selectedOptions.map((item) => item.value);
      const selectedFieldTeamIds = selectedOptionsFeild
        .map((item) => item.value)
        .filter((value) => value !== undefined);
      const updatedTeamIds = [
        ...new Set([...selectedRegularTeamIds, ...selectedFieldTeamIds]),
      ];
      // Check if any regular teams are selected

      const combinedArray = [];
      selectedRegularTeamIds.forEach(() => {
        combinedArray.push(0);
      });

      // Add 1s for each selected field team
      selectedFieldTeamIds.forEach(() => {
        combinedArray.push(1);
      });

      // Increment isFieldCount for each selected field team that is enabled

      // Prepare the register data
      const registerData = {
        tournamentId: editData?.tournamentId,
        tournamentName: editData?.tournamentName,
        // The contest's current logo unless a new one was uploaded: a failed upload keeps it.
        tournamentImage: editLogo.name || null,
        startDate: editData?.startDate,
        endDate: editData?.endDate,
        minBid: editData?.minBid,
        bidIncrement: editData?.bidIncrement,
        sportId: editData?.sportId,
        isField: combinedArray, // Assuming this is how you want to handle isField
        teamId: updatedTeamIds,
      };

      // Uncomment the below block to make the API call

      await TournamentUpdate(registerData).then((res) => {
        if (res?.status === true) {
          toast.success(res?.message);
          setShowEdit(false);
          setCount(count + 1);
        } else {
          toast.error(res?.message);
        }
      });

      // // Reset selected options
      setSelectedOptions([]);
      setSelectedOptionsFeild([]);
    }
  };

  const disabledDate = (date) => {
    return date < startDate;
  };
  const teamNamesArray = editData?.auctionTeamsName
    ? editData.auctionTeamsName.split(",").map((name) => name.trim())
    : [];
  const teamNamesImages = editData?.auctionTeamsImage
    ? editData.auctionTeamsImage.split(",").map((name) => name.trim())
    : [];

  const TournamentGetAllSearch = async (data) => {
    try {
      const response = await TournamentAllDataSearch(data); // Call your API function
      if (response?.data) {
        setItemList(response.data.data.dataList || []); // Set the item list
        setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const clearSearch = () => {
    const data = {
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: false,
    };
    TournamentGetAll(data);
    setSearchText("");
  };
  return (
    <>
      <ConfirmDeleteModal
        show={showDeleteModal}
        entity="contest"
        name={deleteRow?.tournamentName}
        onConfirm={handelDelete}
        onCancel={handleClosed}
      />

      <ModalBox
        show={showView}
        title={
          <>
            <h1 className="heading-dash">View Team</h1>
          </>
        }
        body={
          <>
            <Table bordered>
              <thead>
                <tr>
                  <td
                    className="bg-gray-view"
                    style={{
                      padding: "10px",
                      border: "1px solid #ccc",
                      textAlign: "center",
                    }}
                  >
                    Logo
                  </td>
                  <td
                    className="bg-gray-view"
                    style={{
                      padding: "10px",
                      border: "1px solid #ccc",
                      textAlign: "center",
                    }}
                  >
                    Team Name
                  </td>
                </tr>
              </thead>
              <tbody>
                {/* {teamNamesArray.length > 0 && teamNamesImages.length > 0 ? (
                                        teamNamesArray.map((item, index) => (
                                          <tr key={index}>
                                            <td style={{ padding: '10px', border: '1px solid #ccc', textAlign: 'center' }}>
                                              {teamNamesImages[index] ? (
                                                <img src={ImageUrl + teamNamesImages[index]} alt={item} style={{ width: '50px', height: '50px' }} />
                                              ) : (
                                                <img src="../image/TournmentImage.jpg" alt={item} style={{ width: '50px', height: '50px' }} />
                                              )}
                                            </td>
                                            <td style={{ padding: '10px', border: '1px solid #ccc', textAlign: 'center' }}>{item}</td>
                        
                                          </tr>
                                        ))
                                      ) : (
                                        <tr>
                                          <td colSpan="2">No team names or images available</td>
                                        </tr>
                                      )} */}

                {splitedTeamID?.map((item) =>
                  selectedSportId?.map((value) => {
                    if (item === value?.teamId) {
                      {
                        return (
                          <tr
                            key={value.teamId}
                            style={{
                              padding: "10px",
                              border: "1px solid #ccc",
                              textAlign: "center",
                            }}
                          >
                            <td>
                              <img
                                src={
                                  value?.teamImage
                                    ? ImageUrl + value?.teamImage
                                    : "../image/team-icon.png"
                                }
                                width="50"
                                alt={value?.teamName}
                              />
                            </td>

                            <td
                              style={{
                                padding: "10px",
                                border: "1px solid #ccc",
                                textAlign: "center",
                              }}
                            >
                              {dataListItemTeam[item] === 1
                                ? ` ${value?.teamName} - The Field `
                                : value?.teamName}
                            </td>
                          </tr>
                        );
                      }
                    }

                    return null;
                  })
                )}
              </tbody>
            </Table>
          </>
        }
        footer={
          <>
            <Button variant="secondary" onClick={handleClosed}>
              Close
            </Button>
          </>
        }
      />

      <ModalBox
        show={showEdit}
        onHide={handleClosed}
        title="Update Contest"
        body={
          <>
            {/* #309: the fields of Create Contest, in its order and widths, each group with its
                own controlId; Update used to put the logo first with the name jammed under it. */}
            <Form noValidate validated={validated} className="manager-form" onSubmit={handleUpdate}>
              <Row className="mb-3">
                <Form.Group as={Col} md="12" controlId="edit-contest-name">
                  <Form.Label>Contest Name</Form.Label>
                  <Form.Control
                    type="text"
                    className="form-control"
                    name="tournamentName"
                    value={editData?.tournamentName}
                    required
                    onChange={handelFrom}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter the contest name.
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group
                  as={Col}
                  md="6 mt-3"
                  className="text-left "
                  controlId="edit-contest-sport"
                >
                  <Form.Label>Sports</Form.Label>
                  <InputGroup hasValidation>
                    <Form.Select
                      name="sportId"
                      value={editData?.sportId}
                      onChange={handelFromSport}
                      className="select-option select-sport"
                      required
                      as="select"
                    >
                      <option value={""}>Select Sports</option>
                      {selectedSport?.map((listItem) => (
                        <option
                          key={listItem?.sportID}
                          value={listItem?.sportId}
                        >
                          {listItem?.sportName}
                        </option>
                      ))}
                    </Form.Select>

                    <Form.Control.Feedback type="invalid">
                      Please a select sport name.
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>

                <Form.Group as={Col} md="6 mt-3" controlId="edit-contest-logo">
                  <Form.Label>Logo Image</Form.Label>
                  {/* #308: the page's own picker and hint. */}
                  <ImageFileInput name="imageName" onPick={editLogo.upload} />

                  {/* The logo the update will save, not the file picked: an upload that failed
                      leaves the current one. */}
                  <img
                    src={editLogo.name ? ImageUrl + editLogo.name : "../image/tournament.png"}
                    alt="Logo"
                    width={100}
                  />
                </Form.Group>

                {/* #309: rsuite's picker is not a native input, so Bootstrap's :invalid styles never
                    reach it and these messages could never show. Its red border and message follow
                    the update's own check instead, as on Profile (#108). */}
                <Form.Group
                  as={Col}
                  md="6 mt-3"
                  controlId="edit-contest-start"
                >
                  <Form.Label>Start Date</Form.Label>

                  <DatePicker
                    format="MM/dd/yyyy hh:mm:ss aa"
                    showMeridian
                    value={startDate}
                    name="startDate"
                    className={validated && !editData?.startDate ? "Auction-Date is-invalid" : "Auction-Date"}
                    onChange={handelStartDate}
                    disabledDate={(date) =>
                      date < new Date(new Date().setHours(0, 0, 0, 0))
                    }
                    required
                  />

                  {validated && !editData?.startDate && (
                    <Form.Control.Feedback type="invalid" className="d-block">
                      Please select start date.
                    </Form.Control.Feedback>
                  )}
                </Form.Group>

                <Form.Group
                  as={Col}
                  md="6 mt-3"
                  controlId="edit-contest-end"
                >
                  <Form.Label>End Date</Form.Label>
                  <DatePicker
                    format="MM/dd/yyyy hh:mm:ss aa"
                    showMeridian
                    value={endDate}
                    name="endDate"
                    className={validated && !editData?.endDate ? "Auction-Date is-invalid" : "Auction-Date"}
                    onChange={handelEndDate}
                    disabledDate={disabledDate}
                    required
                  />
                  {validated && !editData?.endDate && (
                    <Form.Control.Feedback type="invalid" className="d-block">
                      Please select end date.
                    </Form.Control.Feedback>
                  )}
                </Form.Group>

                <Form.Group
                  as={Col}
                  md="6 mt-3"
                  className="text-left mt-2"
                  controlId="validationCustomOption"
                >
                  <Form.Label>Regular Teams</Form.Label>
                  <MultiSelect
                    options={getDisabledRegularOptions()}
                    value={selectedOptions}
                    onChange={handelselect}
                    labelledBy={"Select"}
                    className="custom-multiselect-dropdown"
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    Please select a team.
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group
                  as={Col}
                  md="6 mt-3"
                  className="text-left mt-2"
                  controlId="validationCustomOptionField"
                >
                  <Form.Label>Field Teams</Form.Label>
                  <MultiSelect
                    options={getDisabledFieldOptions()}
                    value={selectedOptionsFeild}
                    onChange={handelselectFeild}
                    labelledBy={"Select"}
                    className="custom-multiselect-dropdown"
                  />
                </Form.Group>
              </Row>

              <FormActions onCancel={handleClosed} submitLabel="Update" />
            </Form>
          </>
        }
      />

      <TopNavbar sidebarfun={sidebarfun} />
      <div className="dasboard-group">
        <Sidebar data={data} />
        <div
          className={
            data ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <Row>
            <Col md={6}>
              <h1 className="heading-dash">Contest</h1>
            </Col>
            <Col md={6} className="text-right">
              <Link to="/SuperAdmin/CreateContest">
                {" "}
                <Button className="primary button-create-auction">
                  <icons.Plus class="icon-plus" /> Create Contest
                </Button>
              </Link>
            </Col>
          </Row>

          <div className="group_data_table tournament-list">
            {/* <div className='search-input d-flex align-items-center'>
                        <input type="text" className='form-control mb-3 mt-3' placeholder="Search..." value={searchText} onChange={handleSearch} />
                        </div> */}
            {/* <DataTable
                            title="Contest List"
                            columns={columns}
                            data={filteredData}
                            pagination
                            paginationPerPage={10}
                            paginationRowsPerPageOptions={[10, 20, 30]}
                            paginationTotalRows={filteredData?.length}
                        /> */}
            <div className="search-input d-flex align-items-center">
              <input
                type="text"
                className="form-control mb-3 mt-3"
                placeholder="Search..."
                value={searchText}
                onChange={handleSearch}
              />
              {searchText && (
                <button className="btn btn-clear" onClick={clearSearch}>
                  <span>&times;</span> {/* This represents the close icon */}
                </button>
              )}
            </div>
            <div>
              <DataTable
                title="Contest List"
                columns={columns}
                data={filteredData}
                paginationPerPage={perPage}
                paginationTotalRows={totalRows * 10}
                paginationDefaultPage={currentPage}
                onChangePage={setCurrentPage}
              />
              {totalRows > 1 && (
                <Row>
                  <Col md={12} className="text-right">
                    <div className="pagination-controls">
                      <label>Rows per page: </label>
                      <select
                        id="itemsPerPage"
                        value={perPage}
                        onChange={handlePerPageChange}
                      >
                        {pageOptions.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>

                      <Button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                      >
                        <icons.ArrowLeft></icons.ArrowLeft>
                      </Button>
                      <span>
                        {currentPage} of {totalRows}
                      </span>
                      <Button
                        onClick={handleNextPage}
                        disabled={currentPage >= Math.ceil(totalRows)}
                      >
                        <icons.ArrowRight></icons.ArrowRight>
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}
            </div>
          </div>
        </div>
        <div className={data ? "footer" : "footer-content"}>
          <Footer />
        </div>
      </div>
    </>
  );
};
